import { API } from 'constants/api-endpoints';

import { tokenInstance } from 'lib/axios/instance';

export const deleteCharacter = async (id) => {
  return await tokenInstance.delete(`${API.CHARACTERS}/${id}/delete`);
};
